/* =========================================================================
   PILATIX — Shop the Look behaviour
   - Main CTA button submits the form -> AJAX add to cart
   - Color swatches: click auto-adds THAT variant (with fade animation)
   - On success: checkmark flash, cart count update, open cart drawer
   - Falls back to regular submit if AJAX fails
   ========================================================================= */
(function () {
  'use strict';

  var SELECTOR = '.pltx2-stl';

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function openCartDrawer() {
    var direct = ['cart-drawer', '[data-cart-drawer]', 'cart-notification'];
    for (var i = 0; i < direct.length; i++) {
      var el = document.querySelector(direct[i]);
      if (el && typeof el.open === 'function') { try { el.open(); return true; } catch (e) {} }
    }
    var cd = document.querySelector('cart-drawer');
    if (cd) {
      if (typeof cd.openDrawer === 'function') { cd.openDrawer(); return true; }
      if (typeof cd.showDrawer === 'function') { cd.showDrawer(); return true; }
      cd.classList.add('active', 'is-open', 'open');
      document.body.classList.add('cart-drawer-open', 'overflow-hidden');
      return true;
    }
    var toggles = [
      '#cart-icon-bubble',
      '[data-cart-icon]',
      '.header__icon--cart',
      'a[href="#cart"]',
      '[data-action="toggle-cart"]'
    ];
    for (var j = 0; j < toggles.length; j++) {
      var t = document.querySelector(toggles[j]);
      if (t) { t.click(); return true; }
    }
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('drawer:open', { bubbles: true, detail: { drawer: 'cart' } }));
    document.dispatchEvent(new CustomEvent('pltx:cart:open', { bubbles: true }));
    return false;
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count-bubble').forEach(function (el) {
      el.textContent = count;
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: count }, bubbles: true }));
  }

  /**
   * Re-render the cart drawer from the server.
   *
   * This theme's <cart-drawer> has NO renderContents() method — there is no
   * cart-drawer.js in assets — so the usual ShrineTheme `sections=` handshake
   * silently does nothing here. The drawer's own upsell block works around it
   * by re-fetching the drawer's section and swapping innerHTML; we use the
   * same approach so there is one mechanism, not two.
   *
   * Always resolves, never rejects: a failed repaint must not stop the drawer
   * from opening.
   */
  function refreshCartDrawer() {
    var cd = document.querySelector('cart-drawer');
    if (!cd) return Promise.resolve(false);

    var host = cd.closest('[id^="shopify-section-"]');
    var sectionId = host && host.id.replace('shopify-section-', '');
    if (!sectionId) return Promise.resolve(false);

    return fetch(routeRoot() + '?sections=' + encodeURIComponent(sectionId), {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections && sections[sectionId];
        if (!html) return false;
        var div = document.createElement('div');
        div.innerHTML = html;
        var fresh = div.querySelector('cart-drawer');
        if (!fresh) return false;
        cd.innerHTML = fresh.innerHTML;
        // is-empty lives on <cart-drawer> itself and drives the empty state,
        // so it has to be synced too or the drawer keeps saying "cart is empty"
        // over freshly rendered items.
        cd.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
        return true;
      })
      .catch(function () { return false; });
  }

  /**
   * Add a variant by ID. opts.btn / opts.swatch / opts.item receive UI state.
   */
  function addVariantById(variantId, opts) {
    opts = opts || {};
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', opts.quantity || 1);

    if (opts.btn) { opts.btn.classList.add('is-loading'); opts.btn.disabled = true; }
    if (opts.swatch) opts.swatch.classList.add('is-adding');
    if (opts.item) opts.item.classList.add('is-adding');

    return fetch(routeRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript, application/json' },
      body: fd,
      credentials: 'same-origin'
    }).then(function (r) {
      if (!r.ok) throw new Error('cart-add-failed-' + r.status);
      return r.json();
    }).then(function (parsedState) {
      if (opts.btn) { opts.btn.classList.remove('is-loading'); opts.btn.classList.add('is-success'); }
      if (opts.swatch) { opts.swatch.classList.remove('is-adding'); opts.swatch.classList.add('is-added'); }
      if (opts.item) {
        opts.item.classList.remove('is-adding');
        opts.item.classList.add('is-added');
      }

      // Repaint the drawer BEFORE opening it. This is the actual fix for
      // "the button does nothing": the add always succeeded server-side, but
      // the drawer still held the HTML it was rendered with at page load, so
      // it opened showing the old cart — or the empty state — and the item
      // looked like it was never added.
      refreshCartDrawer().then(function () {
        fetch(routeRoot() + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            openCartDrawer();
          })
          .catch(function () { openCartDrawer(); });
      });

      setTimeout(function () {
        if (opts.btn) { opts.btn.classList.remove('is-success'); opts.btn.disabled = false; }
        if (opts.swatch) opts.swatch.classList.remove('is-added');
        if (opts.item) opts.item.classList.remove('is-added');
      }, 1600);
    }).catch(function (err) {
      console.warn('[pltx-stl] cart add failed', err);
      if (opts.btn) { opts.btn.classList.remove('is-loading'); opts.btn.disabled = false; }
      if (opts.swatch) opts.swatch.classList.remove('is-adding');
      if (opts.item) opts.item.classList.remove('is-adding');
      if (opts.form) { try { opts.form.submit(); } catch (e) {} }
    });
  }

  function init() {
    var roots = document.querySelectorAll(SELECTOR);
    if (!roots.length) return;

    roots.forEach(function (root) {
      // Main CTA: form submit
      root.addEventListener('submit', function (e) {
        var form = e.target.closest('[data-pltx-stl-add]');
        if (!form) return;
        e.preventDefault();
        var btn = form.querySelector('.pltx2-stl__btn');
        var item = form.closest('.pltx2-stl__item');
        var variantId = form.querySelector('input[name="id"]').value;
        addVariantById(variantId, { btn: btn, item: item, form: form });
      });

      // Prevent double-click while in-flight
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('.pltx2-stl__btn');
        if (btn && (btn.classList.contains('is-loading') || btn.classList.contains('is-success'))) {
          e.preventDefault();
        }
      });

      // Swatch click: auto-add THAT variant (even if already the active swatch)
      root.addEventListener('click', function (e) {
        var swatch = e.target.closest('[data-pltx-stl-swatch]');
        if (!swatch) return;
        if (swatch.classList.contains('is-adding') || swatch.classList.contains('is-added')) return;
        var variantId = swatch.getAttribute('data-variant-id');
        if (!variantId) return;
        var item = swatch.closest('.pltx2-stl__item');
        // Mark this swatch active, deactivate siblings
        var group = swatch.closest('.pltx2-stl__swatches');
        if (group) {
          group.querySelectorAll('[data-pltx-stl-swatch]').forEach(function (s) { s.classList.remove('is-active'); });
          swatch.classList.add('is-active');
        }
        addVariantById(variantId, { swatch: swatch, item: item });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:load', init);
})();
